import serviceAccounts from '@/apis/coreIAM/serviceAccounts'
import { serviceAccountsTypes } from '@/store/mutationTypes'

export default {
    state: {
        all: null,
        current: null,
        fetchAll: {
            pending: false,
            error: null
        },
        fetchOne: {
            pending: false,
            error: null,
        },
        createOne: {
            pending: false,
            error: null,
        },
        updateOne: {
            pending: false,
            error: null,
        },
        deleteOne: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [serviceAccountsTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true;
        },
        [serviceAccountsTypes.FETCH_ALL_SUCCESS]: function (state, serviceAccounts) {
            state.all = serviceAccounts;
            state.fetchAll.error = null;
            state.fetchAll.pending = false;
        },
        [serviceAccountsTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.all = null;
            state.fetchAll.error = error;
            state.fetchAll.pending = false;
        },
        [serviceAccountsTypes.FETCH_ONE_REQUEST]: function (state) {
            state.fetchOne.pending = true;
        },
        [serviceAccountsTypes.FETCH_ONE_SUCCESS]: function (state) {
            state.fetchOne.error = null;
            state.fetchOne.pending = false;
        },
        [serviceAccountsTypes.FETCH_ONE_FAILURE]: function (state, error) {
            state.fetchOne.error = error;
            state.fetchOne.pending = false;
        },
        [serviceAccountsTypes.CREATE_ONE_REQUEST]: function (state) {
            state.createOne.pending = true;
        },
        [serviceAccountsTypes.CREATE_ONE_SUCCESS]: function (state) {
            state.createOne.error = null;
            state.createOne.pending = false;
        },
        [serviceAccountsTypes.CREATE_ONE_FAILURE]: function (state, error) {
            state.createOne.error = error;
            state.createOne.pending = false;
        },
        [serviceAccountsTypes.UPDATE_ONE_REQUEST]: function (state) {
            state.updateOne.pending = true;
        },
        [serviceAccountsTypes.UPDATE_ONE_SUCCESS]: function (state) {
            state.updateOne.error = null;
            state.updateOne.pending = false;
        },
        [serviceAccountsTypes.UPDATE_ONE_FAILURE]: function (state, error) {
            state.updateOne.error = error;
            state.updateOne.pending = false;
        },
        [serviceAccountsTypes.DELETE_ONE_REQUEST]: function (state) {
            state.deleteOne.pending = true;
        },
        [serviceAccountsTypes.DELETE_ONE_SUCCESS]: function (state) {
            state.deleteOne.error = null;
            state.deleteOne.pending = false;
        },
        [serviceAccountsTypes.DELETE_ONE_FAILURE]: function (state, error) {
            state.deleteOne.error = error;
            state.deleteOne.pending = false;
        },
    },
    actions: {
        async fetchAll({ commit }) {
            commit(serviceAccountsTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .fetchAll()
                    .then((serviceAccountsList) => {
                        commit(serviceAccountsTypes.FETCH_ALL_SUCCESS, serviceAccountsList.data)
                        resolve(serviceAccountsList.data)
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.FETCH_ALL_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchOne({ commit }, payload) {
            commit(serviceAccountsTypes.FETCH_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .fetchOne(payload.uuid)
                    .then((serviceAccount) => {
                        commit(serviceAccountsTypes.FETCH_ONE_SUCCESS)
                        resolve(serviceAccount.data)
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.FETCH_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async createOne({ commit }, payload) {
            commit(serviceAccountsTypes.CREATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .createServiceAccount(
                        payload.id,
                        payload.name,
                        payload.description,
                    )
                    .then((serviceAccount) => {
                        commit(serviceAccountsTypes.CREATE_ONE_SUCCESS)
                        resolve(serviceAccount.data)
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.CREATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async updateOne({ commit }, payload) {
            commit(serviceAccountsTypes.UPDATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .updateServiceAccount(
                        payload.uuid,
                        payload.id,
                        payload.name,
                        payload.description,
                    )
                    .then((serviceAccount) => {
                        commit(serviceAccountsTypes.UPDATE_ONE_SUCCESS)
                        resolve(serviceAccount.data)
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.UPDATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async deleteOne({ commit }, payload) {
            commit(serviceAccountsTypes.DELETE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .deleteServiceAccount(payload.uuid)
                    .then(() => {
                        commit(serviceAccountsTypes.DELETE_ONE_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.DELETE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}